export const EMPLOYMENT_TYPE = {
    MELLEKALLAS: 10, // Mellékállású (heti 36 órát elérő munkaviszony mellett)
    FOALLAS: 20, // Főállású
    HALLGATO: 30, // Nappali tagozatos hallgató
    TARSAS_MELLEKALLAS: 40, // Társas vállalkozó, társas vállalkozásában fizeti a minimumokat
    TARSAS_FOALLAS: 41, // Társas vállalkozó, egyéni vállalkozásában fizeti a minimumokat
    NYUGDIJAS: 50, // Nyugdíjas
    FOREIGN_INSURED: 60, // Külföldi biztosítottság mellett
};
// The only employment type where the minimum contributions are paid in the
// partnership, so its tax number is required.
export const EMPLOYMENT_TYPE_REQUIRING_PARTNER_TAX_NUMBER = EMPLOYMENT_TYPE.TARSAS_MELLEKALLAS;
export const TAX_FORM = {
    UJKATA: 'ujkata',
    ATALANY: 'atalany',
    VSZJA: 'vszja',
};
export const SZJA_DISCOUNT_TYPE = {
    FOUR_OR_MORE_CHILDREN: 10, // Négy vagy több gyermeket nevelő anyák kedvezménye
    UNDER_25: 20, // 25 év alattiak kedvezménye
    MOTHERS_UNDER_30: 30, // 30 év alatti anyák kedvezménye
    PERSONAL: 40, // Személyi kedvezmény
    FIRST_MARRIED: 50, // Első házasok kedvezménye
    FAMILY: 60, // Családi kedvezmény
    OTHER_BENEFITS: 70, // Egyéb ellátás miatti kedvezmény
};
